import { useContext } from "react";
import { AllDataContext } from "../../../lib/dataContext";
import FiatLogo from "../../../logos/fiat";
import {
  FooterLink,
  Inner,
  LinkContainer,
  FiatFooterContainer,
} from "./styles";

const FiatFooter = () => {
  const data = useContext(AllDataContext);

  const links = data.footerItems.footerLinks;

  return (
    <FiatFooterContainer>
      <Inner>
        <FiatLogo />
        <LinkContainer>
          {links?.map((link) => (
            <FooterLink
              className="p2"
              href={link.href}
              rel="noreferrer noopener"
              target="_blank"
              key={link._key}
            >
              {link.title}
            </FooterLink>
          ))}
        </LinkContainer>
      </Inner>
    </FiatFooterContainer>
  );
};

export default FiatFooter;
